import { TypeOf, yup } from '@guiker/shared-framework'

import { payoutMethodTypeSchema } from './payout-method-type'

export const updateTypeSchema = yup.object({
  type: payoutMethodTypeSchema.required(),
})

export type UpdateTypeSchema = TypeOf<typeof updateTypeSchema>
